/* eslint-disable semi */
import { createDecorator } from 'vue-class-component';
import * as utils from './utils';
import DecoratorConfigs from './DecoratorConfigs';

const debug = process.env.NODE_ENV === 'development';

const DECORATOR_NAME = 'BindErrors';

/**
 * そのコンポーネントがエラー変数を管理することを宣言します
 *
 * 下記のパラメータを指定できます。
 * label: エラー変数名を指定します。
 * resetBefore: 実行前にエラー変数の初期化を行う処理を指定します。
 *
 * resetBeforeで指定された処理時に、エラー変数にデフォルト値
 * (dataメソッドで取得した値)を設定します。
 */
export default function BindErrors (...args) {
  if (utils.isDecoratorCall(args)) {
    createAppDecorator()(...args);
  } else {
    return createAppDecorator(...args);
  }
}

function createAppDecorator (decoratorOptions = {}) {
  // 設定値のマージ
  decoratorOptions = DecoratorConfigs.marge(DECORATOR_NAME, decoratorOptions);

  // 実装時の整合性チェック
  if (debug) {
    utils.validateDecoratorOptions(
      DECORATOR_NAME, {
        label: { type: 'string', mustBe: ['not empty'] },
        resetBefore: { type: 'array', shouldBe: ['not empty'] }
      },
      decoratorOptions
    );
  }

  return createDecorator((options, key) => {
    // 実装時の整合性チェック
    if (debug) {
      console.debug(`${DECORATOR_NAME}: @ ${key}`);

      if (key !== 'data') {
        throw new Error(`${DECORATOR_NAME}: can decorate only data().`);
      }
    }

    // オプション値取得
    const label = decoratorOptions.label || 'errors';
    const resetBefore = decoratorOptions.resetBefore || [];

    // データメソッド
    const data = options.data;

    // created時の処理を追加
    const created = options.created || function () { };
    options.created = utils.injectBefore(created, function () {
      // 実装時の整合性チェック
      if (debug) {
        if (!(label in this)) {
          throw new Error(
            `${DECORATOR_NAME}: ${label} must be declared in data().`
          );
        }
      }
    });

    // 関数をラップして事前処理を追加する
    utils.wrapMethods(options.methods, resetBefore, function () {
      this[label] = data()[label];
    });
  });
}



// WEBPACK FOOTER //
// ./src/core/decorators/BindErrors.js